/**
 * Transform a FavoriteDataSeries object into a DataSeries
 */
export default function favoriteSeriesTransformer(response) {
    if (response.charts && response.charts.length) {
        const chartData = response.charts[0];
        return chartData.series.map((series) => ({
            budgetReverse: series.budget_reverse,
            avg: series.avg,
            max: series.max,
            p50: series.p50,
            p75: series.p75,
            p95: series.p95,
            color: series.color,
            data: series.data,
            dataType: series.dataType,
            endTime: series.endTime,
            metric: series.metric,
            metricQualified: series.metricQualified,
            metricName: series.metricName,
            metricShortName: series.metricShortName || series.metricName,
            metricType: series.metrictype,
            name: series.name,
            notes: chartData.notes,
            alerts: chartData.alerts,
            filters: series.filters,
            isCompareSeries: series.isCompareSeries,
            shortName: series.shortName,
            startTime: series.startTime,
            stat: series.stat || 0,
            statId: series.statid,
            suffix: series.suffix,
            xAxisUnits: series.xAxisUnits,
            xInterval: series.xInterval,
            numLabel: series.numlabel,
            settings: chartData.settings,
            summaryMetric: series.summaryMetric,
            summaryMetricName: series.summaryMetricName,
            summaryMetricSuffix: series.summaryMetricSuffix,
            summaryMetricThresholds: series.summaryMetricThresholds,
            thresholds: series.thresholds,
        }));
    }
    return [];
}
